(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
    typeof define === 'function' && define.amd ? define(factory) :
      (factory());
}(this, (function () {
  'use strict';

  /*
   * on domContentLoaded
   */
  $(function () {
    // $('.x-tab-trigger').click(function (e) {
    //   e.preventDefault();
    //   $('.x-tab-trigger').removeClass('is-active');
    //   $(this).addClass('is-active');
    //   var $tab_target = $(this).find('a').attr('href');
    //   $('.x-tab-target').removeClass('is-active');
    //   $('.x-tab-target' + $tab_target).addClass('is-active');
    // });
    var fixedBody = function() {
      var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
      document.body.style.cssText += 'position:fixed;top:-' + scrollTop + 'px;';
    }

    var looseBody = function() {
      var body = document.body;
      body.style.position = '';
      var top = body.style.top;
      document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top, 10);
      body.style.top = '';
    }
    
    $('#imageMap').find('area').colorbox({
      width: "940px",
      height: "auto",
      onOpen: function () { 
        fixedBody();
      },
      onClosed: function () {
        looseBody();
      }
    });

    $('.fancybox').colorbox({
      iframe: true,
      innerWidth: 900,
      innerHeight: 500,
      scrolling: false
    });
  })

})));

　
